var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",staticStyle:{"padding":"24vh 0 10vh"}},[_c('i',{staticClass:"fa fa-frown-o fa-3x"}),_c('h5',{staticClass:"mt-3"},[_vm._v("Página não encontrada!")]),_c('p',{staticClass:"mb-4"},[_vm._v("O endereço digitado não existe em nosso App.")]),_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":"/"}},[_vm._v("Voltar para Home")])])
}]

export { render, staticRenderFns }